export const RAPID_PRICEBOOK_REGION = 6

export const RAPID_DELIVERY_ALGOLIA_TAG = 'rapidDelivery'
